<template>
  <BaseAction>
    <SecondaryButton
      @click.native="openDeleteBookingDialog"
      textColor="#d10a3a"
    >
      <v-icon>
        mdi-delete-outline
      </v-icon>
      Delete Role
    </SecondaryButton>
    <DeleteBookingDialog
      :isOpen="isDeleteBookingOpen"
      @close="closeDeleteBookingDialog"
    />
  </BaseAction>
</template>

<script>
import DeleteBookingDialog from "@/views/bookings/components/ConfirmDialogs/DeleteBookingDialog";
import SecondaryButton from "@/components/common/Button/SecondaryButton";
import BaseAction from "@/components/common/BaseAction";

export default {
  name: "DeleteBookingAction",
  components: { BaseAction, SecondaryButton, DeleteBookingDialog },
  data() {
    return {
      isDeleteBookingOpen: false
    };
  },
  methods: {
    openDeleteBookingDialog() {
      this.isDeleteBookingOpen = true;
    },
    closeDeleteBookingDialog() {
      this.isDeleteBookingOpen = false;
    }
  }
};
</script>
